import { useMemo } from "react";
import EmployeeApi from "./employeeApi";
import useSessionId from "./useSessionId";

function useEmployeeApi() {
    const [sessionId, ] = useSessionId();
    return useMemo(() => new EmployeeApi(sessionId), [sessionId]);
}

export default useEmployeeApi;
